window.jQuery = window.$ = require('jquery')
const imagesLoaded = require('imagesloaded')

imagesLoaded.makeJQueryPlugin($)

const maskGrid = 10
const allMaskGrid = maskGrid * 15
const loaderMask = document.getElementById('js-loader-mask')
for (let i = 1; i < allMaskGrid + 1; i++) {
  let elm = document.createElement('span')
  elm.classList.add('p-loader-mask__grid')
  loaderMask.appendChild(elm)
}

$(function() {
  showProgress()

  function showProgress() {
    let loader = $('#js-opening-loader')
    let progressBar = loader.find('#js-loader-bar')
    let progressNumber = loader.find('#js-loader-number')

    let imgLoad = imagesLoaded('body')
    let imgTotal = imgLoad.images.length
    let imgLoaded = 0
    let current = 0
    let progressTimer = setInterval(updateProgress, 500 / 20)

    imgLoad.on('progress', function() {
      imgLoaded++
    })

    function updateProgress() {
      var target = (imgLoaded / imgTotal) * 100

      current += (target - current) * 0.1

      progressBar.css({ width: current + '%' })
      progressNumber.text(Math.floor(current))

      if (current >= 100) {
        clearInterval(progressTimer)

        $('body')
          .removeClass('is-loading')
          .addClass('is-loaded')

        $('#js-wrapper').show()

        $('html, body').scrollTop(1)

        loader.fadeOut(500, function() {
          $('#js-loader-mask').addClass('is-loaded')

          $('html, body').scrollTop(0)

          setTimeout(function() {
            $('#js-loader-mask')
              .hide()
              .removeClass('is-loaded')
          }, 1000)
        })
      }

      if (current > 99.9) current = 100
    }
  }
})
